import React, { useState } from 'react';
import { withAdminWriteAccess } from 'contexts/adminAccess';
import AddIcon from '@material-ui/icons/Add';

import ActionButton from 'components/buttons/ActionButton';

import EditBenefitsDialog from './EditBenefitsDialog';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  label: {
    width: '150px',
  },
}));

interface AddBenefitButtonProps {
  validAt?: string;
}

const AddBenefitButton = ({ validAt }: AddBenefitButtonProps) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <ActionButton startIcon={<AddIcon />} onClick={handleOpen} classes={{ label: classes.label }}>
        Add Perk
      </ActionButton>
      {open && <EditBenefitsDialog open={open} onClose={handleClose} validAt={validAt} />}
    </>
  );
};

export default withAdminWriteAccess(AddBenefitButton);
